import React from 'react';
import { BaseTool, IToolManifest, IToolContext, IToolComponentProps, ICommand } from '../../../core/tools/interfaces/ITool';
import { usePerspectiveStore } from '../../../stores/perspectiveStore';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import i18n from '@/i18n/config';
import { bindGenogramToolName } from './utils/toolNameI18n';

const CulturePalettePanel: React.FC<IToolComponentProps> = () => {
  const culturePalette = usePerspectiveStore(s => s.culturePalette);
  const setCultureColor = usePerspectiveStore(s => s.setCultureColor);
  const [newTag, setNewTag] = React.useState('');
  const tags = Object.keys(culturePalette);
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">Culture Palette (diagram)</div>
      <div className="flex items-center gap-2">
        <Input className="h-8 text-sm" placeholder="Add culture" value={newTag} onChange={e => setNewTag(e.target.value)} onKeyDown={e => { if (e.key === 'Enter' && newTag.trim()) { setCultureColor(newTag.trim(), '#84cc16'); setNewTag(''); } }} />
        <Button size="sm" variant="outline" className="h-8" onClick={() => { if (newTag.trim()) { setCultureColor(newTag.trim(), '#84cc16'); setNewTag(''); } }}>Add</Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {tags.map(tag => (
          <div key={tag} className="flex items-center gap-2 border rounded px-2 py-1">
            <Badge variant="outline">{tag}</Badge>
            <input type="color" className="w-6 h-6" value={culturePalette[tag]} onChange={e => setCultureColor(tag, e.target.value)} />
          </div>
        ))}
      </div>
    </div>
  );
};

export class CulturePaletteTool extends BaseTool {
  manifest: IToolManifest = {
    id: 'genogram-culture-palette',
    name: i18n.t('genogram:tools.culturePalette', { defaultValue: 'Culture Palette' }) as string,
    icon: 'palette',
    category: 'edit',
    description: 'Manage diagram-level culture tags and colors',
    version: '1.0.0',
    supportedDiagramTypes: ['genogram'],
    requiresSelection: false,
    ui: { toolbar: false, contextMenu: false, propertyPanel: false, sidebar: false, floatingPanel: false, statusBar: false },
    capabilities: { modifiesShapes: false, createsShapes: false, deletesShapes: false, modifiesConnectors: false, createsConnectors: false, deletesConnectors: false, requiresUserInput: true, supportsMultiSelect: false, supportsBatchOperations: false }
  };

  constructor() {
    super();
    bindGenogramToolName(this.manifest, 'tools.culturePalette', 'Culture Palette');
  }
  canExecute(_context: IToolContext): boolean { return true; }
  execute(): ICommand | null { return null; }
  getPropertyPanelComponent() { return CulturePalettePanel; }
}


